//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function () {
        return {
            text: '',
            texterror: 'Fehlerhafte Eingabe',
            checkbox: null,
            select: '',
            selectselected: 'Google',
            file: null,
            alert: false,
            options: [
                {
                    label: 'Google',
                    value: 'Google'
                },
                {
                    label: 'Facebook',
                    value: 'Facebook'
                },
                {
                    label: 'Twitter',
                    value: 'Twitter'
                },
                {
                    label: 'Apple',
                    value: 'Apple'
                },
                {
                    label: 'Oracle',
                    value: 'Oracle',
                    disable: true
                }
            ],
            category: 3,
            categories: [
                { name: 'Autobewertung' },
                { name: 'Ankaufsabfrage' },
                { name: 'Unser Angebot' },
                { name: 'Fahrzeugdaten' },
                { name: 'Selbstauskunft' },
                { name: 'Ihre Unterlagen' },
                { name: 'Der letzte Klick' }
            ]
        }
    },
    methods: {
        headerCategory (itemCategoryNumber) {
            let headerCategoryClass = 'gt-xs'
            if (itemCategoryNumber === this.category) {
                headerCategoryClass = 'active'
            } else if (itemCategoryNumber < this.category) {
                headerCategoryClass += ' passed'
            } else {
                headerCategoryClass += ''
            }
            return headerCategoryClass
        },
        primaryBadgeStatus () {
            if (this.category >= this.categories.length) return 'e-is--last'
        }
    },
    mounted: function () {
        document.querySelectorAll('.q-checkbox__label a').forEach(item => {
            item.addEventListener('click', event => {
                event.stopPropagation()
            })
        })
    }
}
